import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { ScanElement, ScanningElement } from './fleetScanModels';
import type { APIResponse } from '@store/Shared/shared';

// export const GetScanningElementList = createAsyncThunk(
//   'FleetScan/GetScanningElementList',
//   async ({ catagory, modelId }: { catagory: string; modelId: string }, thunkAPI) => {
//     const { rejectWithValue } = thunkAPI;
//     // /Fleet/GetScanningElementList?Catagory=car&ModelId=531cdd49-91d8-471f-5495-08dbf58c841b
//     try {
//       const { data } = await ntxAPI.get(`Fleet/GetScanningElementList?Catagory=${catagory}&ModelId=${modelId}`);
//       return data;
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const GetScanningElementList = createAsyncThunk(
  'FleetScan/GetScanningElementList',
  async ({ modelId, lookupType }: { modelId?: string; lookupType?: string }, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get('Fleet/GetScanningElementList', {
        params: {
          ModelId: modelId,
          LookupType: lookupType
        }
      });
      // console.log(JSON.stringify(data));

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetScanningElementByCatagory = createAsyncThunk(
  'FleetScan/GetScanningElementByCatagory',
  async ({ catagory, lookupType }: { catagory: string; lookupType?: string }, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get('Fleet/GetScanningElementByCatagory', {
        params: {
          Catagory: catagory,
          LookupType: lookupType || ''
        }
      });
      // console.log(JSON.stringify(data));

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetScanningElementById = createAsyncThunk(
  'FleetScan/GetScanningElementById',
  async (id: string, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get(`Fleet/GetScanningElementById?Id=${id}`);
      return data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const getScanningByAssignationIdIdAndScanningType = createAsyncThunk(
  'FleetScan/getScanningByAssignationIdIdAndScanningType',
  async ({ assignationId, scanningType }: { assignationId: string; scanningType: string }, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get<APIResponse<any>>(`Fleet/GetScanningByAssignationIdIdAndScanningType`, {
        params: {
          AssignationId: assignationId,
          ScanningType: scanningType
        }
      });
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const getScanningByAssignationIdIdAndScanningTypeForPrint = createAsyncThunk(
  'FleetScan/getScanningByAssignationIdIdAndScanningTypeForPrint',
  async ({ assignationId, scanningType }: { assignationId?: string; scanningType?: string }, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const { data } = await ntxAPI.get<APIResponse<any>>(`Fleet/GetScanningByAssignationIdIdAndScanningTypeForPrint`, {
        params: {
          AssignationId: assignationId,
          ScanningType: scanningType
        }
      });
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);




export const AddScanningElement = createAsyncThunk(
  'FleetScan/AddScanningElement',
  async (item: any, { rejectWithValue, dispatch }) => {
    // debugger
    try {
      const { data } = await ntxAPI.post('Fleet/AddScanningElement', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdatScanningElement = createAsyncThunk(
  'FleetScan/UpdatScanningElement',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Fleet/UpdatScanningElement', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  ScanElementList: ScanElement;
  ScanElementList2?: ScanningElement[];
  ScanElement?: ScanningElement;
  loading: boolean;
  loadingById: boolean;
  error: any | null;
} = {
  ScanElementList: {} as ScanElement,
  ScanElementList2: [],
  loading: false,
  loadingById: false,
  error: null
};

const fleetScanSlice = createSlice({
  name: 'FleetScan',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      // .addCase(AddScanningElement.pending, state => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(AddScanningElement.fulfilled, (state, action: PayloadAction<any>) => {
      //   state.loading = false;
      //   if (action?.payload?.succeeded === true) {
      //     state.ScanElementList.scanningElements.push(action.payload?.data);
      //   }
      // })
      // .addCase(AddScanningElement.rejected, (state, action: PayloadAction<any>) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })
      //
      .addCase(GetScanningElementList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(GetScanningElementList.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        if (action.payload.succeeded === true) {
          state.ScanElementList = action.payload.data;
        }
      })
      .addCase(GetScanningElementList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //
      .addCase(GetScanningElementByCatagory.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(GetScanningElementByCatagory.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;

        if (action.payload.succeeded === true) {
          state.ScanElementList2 = action.payload.data;
        }
      })
      .addCase(GetScanningElementByCatagory.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //
      .addCase(GetScanningElementById.pending, (state, action) => {
        state.loadingById = true;
      })
      .addCase(GetScanningElementById.fulfilled, (state, action: PayloadAction<any>) => {
        state.loadingById = false;
        state.ScanElement = action.payload;
      })
      .addCase(GetScanningElementById.rejected, (state, action: PayloadAction<any>) => {
        state.loadingById = false;
        state.error = action.payload;
      });
  }
});

export default fleetScanSlice.reducer;
